import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'idPrefixRemover',
})
export class IdPrefixRemoverPipe implements PipeTransform {
  readonly zigbeePrefix = 'zigbee-';

  transform(value: string): string {
    if (typeof value !== 'string') {
      return '';
    }

    if (value.startsWith(this.zigbeePrefix)) {
      return value.replace(this.zigbeePrefix, '').toLowerCase();
    } else {
      return value;
    }
  }
}
